import * as tslib_1 from "tslib";
import { Component, Inject } from "vue-property-decorator";
import { CheckboxGroupControl } from "@cloudpivot/form/src/common/controls/checkbox-group-control";
import { Radio, Checkbox } from "@h3/antd-vue";
let CheckboxGroup = class CheckboxGroup extends CheckboxGroupControl {
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    onChange(value) {
        this.hasBatchImport = false;
        const val = value && value.length > 0 ? value.filter((x) => !!x) : null;
        this.setValue(val);
        super.resetCheckboxOptionDisabled();
    }
    onRadioChange(evt) {
        this.hasBatchImport = false;
        const val = evt.target.value;
        this.setValue(val);
    }
};
tslib_1.__decorate([
    Inject()
], CheckboxGroup.prototype, "layoutTypeFn", void 0);
CheckboxGroup = tslib_1.__decorate([
    Component({
        name: "checkbox-group",
        components: {
            ARadioGroup: Radio.Group,
            ACheckboxGroup: Checkbox.Group,
        },
    })
], CheckboxGroup);
export default CheckboxGroup;
